import { useDataSubmit } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'

export function useOnClose(props) {
  let submit = useDataSubmit({
    context: 'connection',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    submit({ type: 'cancel-oauth2-authorization-code-connection' })
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
